import { ApolloClient, InMemoryCache } from '@apollo/client';
import * as E from 'fp-ts/lib/Either';
import { pipe } from 'fp-ts/lib/function';
import * as T from 'fp-ts/lib/Task';

import { User } from '@domain/auth';
import { Lang } from '@domain/language-negotiation';

import { getBrowserPreferredLanguage } from '@repositories/language-negotiation/pipelines';

import { negotiateLangByIndividualId } from '@domui-repositories/language-negotiation/pipelines';

// getBrowserOrPreferredLang :: (pageContextLanguage: Lang, client: ApolloClient<InMemoryCache>, { isLoggedIn, individualId }: Partial<User>) -> Lang
export const getBrowserOrPreferredLang = (
  pageContextLanguage: Lang,
  client: ApolloClient<InMemoryCache>,
  { isLoggedIn, individualId }: Partial<User>
) =>
  pipe(
    T.of(pageContextLanguage || getBrowserPreferredLanguage(navigator)()),
    E.fromPredicate(
      () => !isLoggedIn || !individualId,
      () => negotiateLangByIndividualId(client, individualId || '')
    ),
    E.getOrElse((a: T.Task<Lang>) => a)
  );
